let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ONW5s")).then(() => parcelRequire('4a4Fm'));